import { render, staticRenderFns } from "./CustomPageSkeletonLoader.vue?vue&type=template&id=11e99900&scoped=true"
import script from "./CustomPageSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./CustomPageSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./CustomPageSkeletonLoader.vue?vue&type=style&index=0&id=11e99900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e99900",
  null
  
)

export default component.exports